<template>
  <div>
    <button class="button logout" @click="logout" v-if="user">
      <span class="tooltip">Sign Out</span>
      <i class="material-icons">person</i>
      <i class="material-icons">close</i>
    </button>
    <button class="button" @click="toggled = true" v-if="!user">
      <span class="tooltip">Sign In</span>
      <i class="material-icons">person</i>
    </button>
    <div class="modal" v-if="toggled && !user">
      <div class="dialog">
        <header>
          <h2>Sign In</h2>
        </header>
        <form class="form" @submit.prevent="login({email, password})">
          <div class="fields">
            <div class="field">
              <label>Email</label>
              <input type="email" v-model="email" required />
            </div>
            <div class="field">
              <label>Password</label>
              <input type="password" v-model="password" required />
            </div>
          </div>
          <div class="actions">
            <button class="button">Login</button>
          </div>
        </form>
      </div>
      <div class="scrim" @click="toggled = false" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data: () => ({
    email: '',
    password: '',
    toggled: false
  }),
  props: {
    user: Object
  },
  methods: {
    ...mapActions([
      'login',
      'logout'
    ])
  },
  watch: {
    user(val) {
      if (!val) {
        this.toggled = false
        this.email = ''
        this.password = ''
      }
    }
  }
}
</script>

<style lang="stylus">

</style>